import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

interface Props {
    data: {
        productTitle: string;
        dateInfo: string;
        productCountInfo: string;
        positionInfo: string;
        _disable: false;
    };
}

class Sight extends Component<Props> {
    public static formatData(data: any) {
        const newData = { ...data };
        if(newData.sysCode == 6003)
        {
            newData.title = newData.orderTitle ? newData.orderTitle : '门票';
        }
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // icon
        newData.iconfont = '\uf1f6';
        newData.iconColor = '#1bc366';
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        // 截止日小黄条
        if (newData.payDeadline) {
            newData.deadlineNotice = `请于${newData.payDeadline}前完成支付`;
        }
        newData.dateInfo = newData.dateInfo && newData.dateInfo.trim();
        newData.productCountInfo = newData.productCount && `数量${newData.productCount}`;
        newData.positionInfo = newData.position && `  看台 ${newData.position}`;

        return newData;
    }

    public render() {
        const {
            data: { productTitle, dateInfo, productCountInfo, positionInfo, _disable } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                {Boolean(productTitle) && (
                    <Text style={styles.newOrderTitle} numberOfLines={2} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TICKET_TITLE)}>
                        {productTitle}
                    </Text>
                )}
                {Boolean(dateInfo) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TICKET_VALID_TIME)}>
                        {dateInfo}
                    </Text>
                )}
                {Boolean(productCountInfo || positionInfo) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.TICKET_COUNT)}>
                        {productCountInfo}
                        {positionInfo}
                    </Text>
                )}
            </View>
        );
    }
}

export default Sight;
